import classNames from 'classnames';
import moment from 'moment';
import { bool } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { compose } from 'redux';
import {
  BrandingIconCard,
  Button,
  IconSpinner,
  Modal,
  NamedLink,
  NamedRedirect,
  PaginationLinks
} from '../../components';
import IconCollection from '../../components/IconCollection/IconCollection';
import LayoutSingleColumn from '../../components/LayoutComposer/LayoutSingleColumn/LayoutSingleColumn';
import Page from '../../components/Page/Page';
import { useConfiguration } from '../../context/configurationContext';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { isScrollingDisabled, manageDisableScrolling } from '../../ducks/ui.duck';
import { Events, mixPanelEventsConstants, mixPanelEventsData, mixPanelEventsScreens } from '../../mixpanel';
import { trackEventsMixpanel } from '../../mixpanel/mixpanel';
import { DEAL_PROCESS_NAME, isBookingProcess, resolveLatestProcessName } from '../../transactions/transaction';
import { transitions as dealTransitions } from '../../transactions/transactionProcessDeal';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { createResourceLocatorString } from '../../util/routes';
import { isMerchantFullyOnboarded } from '../../util/onboardingHelpers';
import { types as sdkTypes } from '../../util/sdkLoader';
import { InboxItem } from '../InboxPage/InboxPage';
import { getStateData } from '../InboxPage/InboxPage.stateData';
import { handleDownloadReport, reFetchAnalytics } from '../LandingPage/LandingPage.duck';
import { getOwnListingsById } from '../ManageListingsPage/ManageListingsPage.duck';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import DashboardData from '../ViewListing/DashboardData';
import css from './DashboardPage.module.css';
import { CHOOSE_PROFILE, UPDATE_PROFILE } from '../MerchantDetailsPage/MerchantDetailsPage';
const { UUID } = sdkTypes;


const DashboardPageComponent = props => {
  const config = useConfiguration();
  const routes = useRouteConfiguration();
  const history = useHistory();
  const arabicLanguage = typeof window !== 'undefined' && localStorage.getItem("language") === "Arabic";

  const {
    currentUser,
    fetchInProgress,
    fetchOrdersOrSalesError,
    intl,
    pagination,
    params,
    providerNotificationCount,
    scrollingDisabled,
    allTransactions,
    onManageDisableScrolling,
    transactions,
    appState,
    listings = [],
    fetchAnalyticsRequest,
    fetchAnalyticsSuccess,
    fetchAnalyticsError,
    onReFetchAnalytics,
    downloadReportRequest,
    downloadReportSuccess,
    downloadReportError,
    onHandleDownloadReport
  } = props;

  const {
    top_4_services,
    sales,
    revenue,
    today_sales,
    completed_items,
    purchased_items,
    filtered_sales,
    filtered_revenue,
    filtered_today_sales,
    filtered_completed_items,
    filtered_purchased_items,
    staff_details,
    weekly_payments,
  } = fetchAnalyticsSuccess || {};


  // Find Total Deals
  const totalDeals = listings.length;

  // Find Active Deals
  const activeDeals = listings.filter(deal => {
    const { deal_end_date } = deal.attributes.publicData || {};
    return moment.unix(deal_end_date).isAfter(moment());
  });

  const draftId = '00000000-0000-0000-0000-000000000000';
  const draftSlug = 'draft';
  const currentUserId = currentUser?.id.uuid;
  // Modal moved to TopbarDesktop component
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const merchantPublicData = currentUser?.attributes?.profile?.publicData || {};
  const {
    userType,
    profileType,
    isPayoutCreated,
    isPhoneNumberVerified,
  } = merchantPublicData;

  // Includes the agreement, so the payout prompt never jumps ahead of signing.
  const isOnboardingComplete = isMerchantFullyOnboarded(currentUser);

  useEffect(() => {
    if (isPhoneNumberVerified && isOnboardingComplete && profileType && !isPayoutCreated) {
      setShowPaymentModal(true);
    }
    trackEventsMixpanel(Events.MERCHANT_SIGN_IN,
      {
        action_type: mixPanelEventsData.VIEW_DASHBOARD,
        screen: mixPanelEventsScreens.HOME,
        user_type: 'provider',
        user_id: currentUserId,
      }
    );
  }, []);

  if (!isPhoneNumberVerified || !profileType) {
    return <NamedRedirect name="MerchantDetailsPage" params={{ screen: UPDATE_PROFILE }} />;
  }

  const hasNoResults = !fetchInProgress && allTransactions.length === 0 && !fetchOrdersOrSalesError;

  const date = new Date();
  const options = { year: 'numeric', month: 'short', day: '2-digit' };
  const formattedDate = date.toLocaleDateString('en-US', options);

  // Filter Today's transactions
  const filteredTransactions = transactions.filter(transaction => {
    const lastTransitionDateStr = transaction?.attributes?.lastTransitionedAt;

    if (lastTransitionDateStr) {
      const lastTransitionDate = new Date(lastTransitionDateStr);
      const formattedLastTransitionDate = lastTransitionDate.toLocaleDateString('en-US', options);
      return formattedLastTransitionDate === formattedDate;
    }
    return false;
  });

  // Calculate Today's sales in cents
  // const soldToday = filteredTransactions.reduce((total, transaction) => {
  //   const saleAmount = transaction?.attributes?.payinTotal?.amount || 0;
  //   return total + saleAmount;
  // }, 0);

  const soldToday = filteredTransactions?.length || 0

  // Calculate Total sales in cents
  // const totalSales = transactions.reduce((total, transaction) => {
  //   const saleAmount = transaction?.attributes?.payinTotal?.amount || 0;
  //   return total + saleAmount;
  // }, 0);

  const totalSales = transactions?.length || 0;

  const pickType = lt => conf => conf.listingType === lt;
  const findListingTypeConfig = publicData => {
    const listingTypeConfigs = config.listing?.listingTypes;
    const { listingType } = publicData || {};
    const foundConfig = listingTypeConfigs?.find(pickType(listingType));
    return foundConfig;
  };

  const hasOrderOrSaleTransactions = (tx, user) => {
    return user?.id && tx && tx.length > 0 && tx[0].provider.id.uuid === user?.id?.uuid;
  };

  const hasTransactions = !fetchInProgress && hasOrderOrSaleTransactions(transactions, currentUser);

  const toTxItem = tx => {
    const transactionRole = 'provider';
    let stateData = null;
    try {
      stateData = getStateData({ transaction: tx, transactionRole, intl });
    } catch (error) {
      // If stateData is missing, omit the transaction from InboxItem list.
    }

    const publicData = tx?.listing?.attributes?.publicData || {};
    const foundListingTypeConfig = findListingTypeConfig(publicData);
    const { transactionType, stockType } = foundListingTypeConfig || {};
    const process = tx?.attributes?.processName || transactionType?.transactionType;
    const transactionProcess = resolveLatestProcessName(process);
    const isBooking = isBookingProcess(transactionProcess);

    // Render InboxItem only if the latest transition of the transaction is handled in the `txState` function.
    return stateData ? (
      <li key={tx.id.uuid} className={css.listItem}>
        <InboxItem
          transactionRole={transactionRole}
          tx={tx}
          intl={intl}
          stateData={stateData}
          stockType={stockType}
          isBooking={isBooking}
        />
      </li>
    ) : null;
  };

  return (
    <Page title={''} scrollingDisabled={scrollingDisabled} referrer="origin">
      <LayoutSingleColumn
        className={css.mainLayout}
        mainColumnClassName={css.layoutWrapperMain}
        topbar={<TopbarContainer />}
      >
        <div className={classNames(css.dashboardWrapper, arabicLanguage && css.arabicText)}>
          <div className={css.dashboardHeader}>
            <div className={classNames(css.dashboardHeading, arabicLanguage && css.arabicText)}>
              <FormattedMessage id="DashboardPage.hello" /> {currentUser?.attributes?.profile?.firstName},
            </div>
            <div className={classNames(css.dashboardSubHeading, arabicLanguage && css.arabicText)}>
              <FormattedMessage id="DashboardPage.summary" />
            </div>
          </div>

          {/* Wallet Banner */}
          <NamedLink
            name="MerchantWalletPage"
            className={css.walletBanner}
          >
            <div className={classNames(css.walletBannerContent, arabicLanguage && css.arabicText)}>
              <div className={css.walletBannerIcon}>
                <BrandingIconCard type="wallet" />
              </div>
              <div className={css.walletBannerText}>
                <div className={css.walletBannerTitle}>
                  <FormattedMessage id="DashboardPage.walletBannerTitle" defaultMessage="View Your Wallet" />
                </div>
                <div className={css.walletBannerSubtitle}>
                  <FormattedMessage id="DashboardPage.walletBannerSubtitle" defaultMessage="Check your balance and transaction history" />
                </div>
              </div>
              <div className={css.walletBannerArrow}>
                →
              </div>
            </div>
          </NamedLink>

          {/* Dashboard Data */}
          <div className={css.dashboardBody}>
            <DashboardData
              activeDeals={activeDeals}
              totalDeals={totalDeals}
              totalSales={totalSales}
              soldToday={soldToday}
              listingType={"none"}
              intl={intl}
              fetchAnalyticsRequest={fetchAnalyticsRequest}
              analyticsData={fetchAnalyticsSuccess}
              fetchAnalyticsError={fetchAnalyticsError}
              currentUser={currentUser}
              onReFetchAnalytics={onReFetchAnalytics}
              downloadReportRequest={downloadReportRequest}
              downloadReportSuccess={downloadReportSuccess}
              downloadReportError={downloadReportError}
              onHandleDownloadReport={onHandleDownloadReport}
            />

            <div className={css.bookingOrder}>
              <div className={classNames(css.bookingHeader)}>
                <div className={css.bookingHeading}>
                  {intl.formatMessage({ id: 'DashboardPage.latestBookings' })}
                </div>
              </div>
              <div className={css.tableWrapper}>
                <ul className={classNames(css.itemList, arabicLanguage && css.arabicText)}>
                  <div className={classNames(css.bookingTable)}>
                    <table>
                      <thead>
                        <tr>
                          <th>
                            {intl.formatMessage({ id: "InboxPage.imageHeading" })}
                          </th>
                          <th>
                            {intl.formatMessage({ id: "InboxPage.nameHeading" })}
                          </th>
                          <th>
                            {intl.formatMessage({ id: "InboxPage.titleHeading" })}
                          </th>
                          <th>
                            {intl.formatMessage({ id: 'InboxPage.bookingTimeHeading' })}
                          </th>
                          <th>
                            {intl.formatMessage({ id: "InboxPage.statusHeading" })}
                          </th>
                          <th>
                            {intl.formatMessage({ id: "InboxPage.invoiceIdHeading" })}
                          </th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                  {!fetchInProgress ? (
                    allTransactions.map(toTxItem)
                  ) : (
                    <li className={css.listItemsLoading}>
                      <IconSpinner />
                    </li>
                  )}
                  {hasNoResults ? (
                    <li key="noResults" className={css.noResults}>
                      <FormattedMessage id={'InboxPage.noSalesFound'} />
                    </li>
                  ) : null}
                </ul>
              </div>
              {hasTransactions && pagination && pagination.totalPages > 1 ? (
                <PaginationLinks
                  className={css.pagination}
                  pageName="LandingPage"
                  // pagePathParams={params}
                  pagination={pagination}
                />
              ) : null}
            </div>
          </div>

          <Modal
            className={css.importantUpdateModal}
            id="ImportantUpdateModal"
            isOpen={showPaymentModal}
            onClose={() => setShowPaymentModal(false)}
            usePortal
            onManageDisableScrolling={onManageDisableScrolling}
          >
            <div className={css.container}>
              <div className={css.icon}>
                <IconCollection name="important_update" />
              </div>
              <h2 className={css.title}>
                <FormattedMessage id="DashboardPage.importantUpdate" />
              </h2>
              <p className={css.description}>
                <FormattedMessage id="DashboardPage.youNeed" />
              </p>
              <ul className={css.requirements}>
                {/* <li>
                  <FormattedMessage id="DashboardPage.ownersID" />
                </li> */}
                <li>
                  <FormattedMessage id="DashboardPage.commercialRegistrationFreelancer" />
                </li>
                <li>
                  <FormattedMessage id="DashboardPage.digitalIBAN" />
                </li>
                <li>
                  <FormattedMessage id="DashboardPage.vatCertificate" />
                </li>
              </ul>
              <div className={css.actions}>
                <button
                  className={css.addButton}
                  onClick={() => {
                    setShowPaymentModal(false);
                    history.push(createResourceLocatorString('StripePayoutPage', routes, {}, {}));
                    trackEventsMixpanel(Events.MERCHANT_PAYOUT_COMPLETED,
                      {
                        action_type: mixPanelEventsData.ADD_PAYOUT_DETAILS,
                        screen: mixPanelEventsScreens.HOME,
                        user_type: 'provider',
                        user_id: currentUserId,
                      }
                    );
                  }}
                >
                  <FormattedMessage id="DashboardPage.paymentDetails" />
                </button>

                {/* <button className={css.updateLater} onClick={() => setShowPaymentModal(false)}>
                  <FormattedMessage id="DashboardPage.updateLater" />
                </button> */}
              </div>
            </div>
          </Modal>
          {/* Complete Onboarding Modal moved to TopbarDesktop component */}
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};
DashboardPageComponent.defaultProps = {};
DashboardPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const {
    fetchInProgress,
    fetchOrdersOrSalesError,
    pagination,
    transactionRefs,
    currentPageResultIds,
    fetchAnalyticsRequest,
    fetchAnalyticsSuccess,
    fetchAnalyticsError,
    downloadReportRequest,
    downloadReportSuccess,
    downloadReportError,
  } = state.LandingPage;

  const {
    // currentPageResultIds,
    queryInProgress,
    queryListingsError,
    queryParams,
    openingListing,
    openingListingError,
    closingListing,
    closingListingError,
  } = state.ViewListingsPage;

  const { currentUser, currentUserNotificationCount: providerNotificationCount } = state.user;
  const listings = getOwnListingsById(state, currentPageResultIds);

  /////
  const allTransactions = getMarketplaceEntities(state, transactionRefs);
  const onlyServiceNDeals = allTransactions.filter(tx =>
    !tx?.attributes?.transitions?.some(t =>
      t.transition === dealTransitions.CHILD_PRODUCT_REQUEST_PAYMENT ||
      t.transition === dealTransitions.CHILD_SERVICE_REQUEST_PAYMENT
    )
  );

  const filteredTransactions = onlyServiceNDeals.filter(
    tx => ["default-deal-booking", "default-deal-purchase"].includes(tx?.attributes?.processName)
  );


  const getBookingFromChildTransaction = (state, childTransactionIds) => {
    const childTransactionRefs = childTransactionIds.map(
      id => ({ id: new UUID(id), type: "transaction" })
    );

    const childTransactions = getMarketplaceEntities(state, childTransactionRefs);

    return childTransactions.find(childTx =>
      childTx?.attributes?.transitions?.some(t =>
        t.transition === dealTransitions.CHILD_PRODUCT_REQUEST_PAYMENT ||
        t.transition === dealTransitions.CHILD_SERVICE_REQUEST_PAYMENT
      )
    )?.booking;
  };

  const updatedBookings = onlyServiceNDeals?.map(tx => {
    const { processName, protectedData, lineItems = [] } = tx?.attributes || {};
    const { dealChildTransactions = [] } = protectedData || {};
    const isDealBooking = processName === DEAL_PROCESS_NAME;

    let updatedLineItems = [...lineItems];

    if (isDealBooking) {
      // Modify the line item code for deals
      updatedLineItems = lineItems.map(item => {
        if (item?.code === 'line-item/day') {
          return {
            ...item,
            code: 'line-item/hour'
          };
        }
        return item;
      });

      // Handle child booking replacement
      if (dealChildTransactions.length > 0) {
        const childBooking = getBookingFromChildTransaction(state, dealChildTransactions);
        if (childBooking) {
          return {
            ...tx,
            booking: childBooking,
            attributes: {
              ...tx.attributes,
              lineItems: updatedLineItems
            }
          };
        }
      }

      // If no child booking, still update line items
      return {
        ...tx,
        attributes: {
          ...tx.attributes,
          lineItems: updatedLineItems
        }
      };
    }

    // If not a deal booking, return as-is
    return { ...tx };
  });
  //////

  return {
    currentUser,
    fetchInProgress,
    fetchOrdersOrSalesError,
    pagination,
    providerNotificationCount,
    scrollingDisabled: isScrollingDisabled(state),
    transactions: filteredTransactions,
    allTransactions: updatedBookings,
    appState: state,
    currentPageResultIds,
    queryInProgress,
    queryListingsError,
    queryParams,
    openingListing,
    openingListingError,
    closingListing,
    closingListingError,
    listings,
    fetchAnalyticsRequest,
    fetchAnalyticsSuccess,
    fetchAnalyticsError,
    downloadReportRequest,
    downloadReportSuccess,
    downloadReportError,
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  onReFetchAnalytics: (data) => dispatch(reFetchAnalytics(data)),
  onHandleDownloadReport: data => dispatch(handleDownloadReport(data)),
});

const DashboardPage = compose(connect(mapStateToProps, mapDispatchToProps), injectIntl)(DashboardPageComponent);
export default DashboardPage;
